import { createSlice } from '@reduxjs/toolkit';
import { fetchTeamMembers } from '../actions/teamMembersActions';
import { TeamMembersState } from '../types/teamMembersTypes';

const initialState: TeamMembersState = {
  teamMembers: [],
  loading: false,
  error: null,
};

const teamMembersSlice = createSlice({
  name: 'teamMembers',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchTeamMembers.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTeamMembers.fulfilled, (state, action) => {
        state.loading = false;
        state.teamMembers = action.payload;
      })
      .addCase(fetchTeamMembers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default teamMembersSlice.reducer; 
